import React from "react";

import { PhoneMockup } from "./PhoneMockup";
import { StoreButtons } from "./StoreButtons";
import { UsersBadge } from "./UsersBadge";

const HeroSection: React.FC = () => {
  return (
    <div>
      <div className="hidden min-[1200px]:block">
        <div className="relative min-h-[720px]">
          <div className="grid grid-cols-12 items-start">

            {/* LEFT */}
            <div className="col-span-5 mt-9">
              <h1 className="
                text-[64px]
                leading-[1.1]
                font-regular
                tracking-[-1px]
                text-[#1A1A1A]
              ">
                Canada's All-In-<br/>
                One Coupon & <br/>
                Rewards App
              </h1>
              <div className="mt-8">
                <StoreButtons />
              </div>
            </div>

            {/* RIGHT TEXT */}
            <div className="col-span-4 col-start-9">
              <div className="w-5 h-48 ..."></div>
              <p className="
                text-[20px]
                leading-[32px]
                text-[#444]
              ">
                Thousands of Canadians are saving money and earning Coupon Points so they can go out and do more.
              </p>
              <div className="mt-4">
                <UsersBadge />
              </div>
            </div>

          </div>

          {/* FLOATING PHONE */}
          <div className="
            absolute
            left-1/2
            top-[20px]
            -translate-x-1/2
            z-30
            pointer-events-none
          ">
            <PhoneMockup />
          </div>

          <style>
            {'.animate-floatSlow { animation: floatSlow 6s ease-in-out infinite;}'}
          </style>
        </div>
      </div>

      <div className="hidden md:block min-[1200px]:hidden">
        <div className="relative min-h-[720px]">
          <div className="grid grid-cols-12 items-start">

            {/* LEFT */}
            <div className="col-span-5 mt-9">
              <h1 className="
                text-[36px]
                leading-[1.1]
                font-regular
                tracking-[-1px]
                text-[#1A1A1A]
              ">
                Canada's All-In-<br/>
                One Coupon & <br/>
                Rewards App
              </h1>
              <div className="mt-8">
                <StoreButtons />
              </div>
            </div>

            {/* RIGHT TEXT */}
            <div className="col-span-4 col-start-9 mt-[50px] max-[900px]:mt-[180px]">
              <div className="w-5 h-48 ..."></div>
              <p className="
                text-[20px]
                leading-[32px]
                text-[#444]
              ">
                Thousands of Canadians are saving money and earning Coupon Points so they can go out and do more.
              </p>
              <div className="mt-4">
                <UsersBadge />
              </div>
            </div>

          </div>

          {/* FLOATING PHONE */}
          <div className="
            absolute
            left-1/2
            top-[20px]
            -translate-x-1/2
            z-30
            pointer-events-none
          ">
            <PhoneMockup />
          </div>

          <style>
            {'.animate-floatSlow { animation: floatSlow 6s ease-in-out infinite;}'}
          </style>
        </div>
      </div>

      {/* MOBILE */}
      <div className="block lg:hidden md:hidden">
        <div className="relative min-h-[650px]">
          <div className="items-start">

            {/* HEADING */}
            <div>
              <h1 className="
                text-[28px]
                text-center
                font-regular
                tracking-[-1px]
                text-3xl leading-none
                text-[#1A1A1A]
              ">
                Canada's All-In-One Coupon & Rewards App
              </h1>
            </div>

            {/* SUBTEXT */}
            <div>
              <p className="
                text-[12px]
                text-center
                text-[#444]
                mt-4
              ">
                Thousands of Canadians are saving money and earning Coupon Points so they can go out and do more.
              </p>
            </div>

          </div>

          {/* PHONE — pointer-events-none, image only */}
          <div className="pointer-events-none flex items-center gap-4 flex-col">
            <div className="absolute bottom-1/3">
              <PhoneMockup />
            </div>
          </div>

          {/* BADGE — outside pointer-events-none */}
          <div className="absolute bottom-52 left-1/2 -translate-x-1/2 z-10">
            <UsersBadge />
          </div>

          {/* STORE BUTTONS — outside pointer-events-none */}
          <div className="absolute bottom-20 left-1/2 -translate-x-1/2 z-10">
            <StoreButtons />
          </div>

        </div>
      </div>

    </div>
  );
};

export default HeroSection;